<template>
  <!-- Coming soon page-->
  <div class="misc-wrapper">
    <!-- Brand logo-->
    <b-link class="brand-logo">
      <b-img :src="logoUrl" />
    </b-link>
    <!-- /Brand logo-->

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          We are launching soon 🚀
        </h2>
        <p class="mb-3">
          We're creating something awesome. Please subscribe to get notified when it's ready!
        </p>

        <!-- form -->
        <b-form
            inline
            class="row justify-content-center m-0 mb-2"
            @submit.prevent
        >
          <b-form-input
              id="notify-email"
              class="col-12 col-md-5 mb-1 mr-md-2"
              type="text"
              placeholder="john@example.com"
          />

          <b-button
              variant="primary"
              class="mb-1 btn-sm-block"
              type="submit"
          >
            Notify
          </b-button>
        </b-form>

        <b-img
            fluid
            :src="imgUrl"
            alt="Coming soon page"
        />
      </div>
    </div>
  </div>
  <!-- / Coming soon page-->
</template>

<script>
/* eslint-disable global-require */
import {
  BLink, BForm, BFormInput, BButton, BImg,
} from 'bootstrap-vue'
import DarkLogo from '@core/layouts/components/Logo.vue'
import LightLogo from '@core/layouts/components/LogoLight.vue'
import store from '@/store/index'

export default {
  components: {
    DarkLogo,
    LightLogo,
    BLink,
    BForm,
    BButton,
    BFormInput,
    BImg,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/coming-soon.svg'),
      logoImg: require('@/assets/images/logo/logo-light.svg'),
      skin: this.$store.state.appConfig.layout.skin,
    }
  },
  computed: {
    logoUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.logoImg = require('@/assets/images/logo/logo-dark.svg')
        return this.logoImg
      }
      return this.logoImg
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/coming-soon-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
